import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// components
import MainHeader from "../../components/Header/MainHeader";
import SelectOption from "../../components/Select/SelectOption";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addPaymentMode } from "../../redux/slices/registerSlice";
import { googleEvent_LOJ060 } from "../../lib/google-analytics";
import { googleEvent_LOJ196 } from "../../lib/google-analytics-loan-journey-events";

export default function PaymentMode() {
  const [loading, setLoading] = useState(false);

  const { paymentMode } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();

  const data = ["Bank Transfer", "Cheque", "Cash"];

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    setLoading(true);

    if (repeatCustomer) {
      dispatch(addPaymentMode(data.value));
      navigate("/confirm-details");
    } else {
      const res = await incompleteDetailsUpdate(data, repeatCustomer);
      if (res) {
        dispatch(addPaymentMode(data.value));
        handleStep();
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    googleEvent_LOJ196();
  }, []);

  return (
    <>
      <div className="wrapper">
        <MainHeader
          title="Professional Details"
          showProgress={true}
          percent={38.45}
          backPageName={repeatCustomer ? "/confirm-details" : ""}
        />

        <div className="mb-3">
          <p className="label">Mode of Payment</p>
        </div>

        {data.map((item, index) => (
          <div
            key={index}
            onClick={async () => {
              handleIncompleteDetailsUpdateAPI({
                key: "salaryMode",
                value: item,
              });

              // Events
              googleEvent_LOJ060(item, item);
            }}
          >
            <SelectOption name={item} checked={paymentMode} />
          </div>
        ))}
      </div>

    </>
  );
}
